import { SliceCaseReducers } from '@reduxjs/toolkit'
import CreateGenericSlice from '../GenericSlice'

const store = CreateGenericSlice<
  QueueViewModel,
  SliceCaseReducers<QueueViewModel>
>({
  name: 'Queue',
  initialState: {},
  reducers: {
    setQueueRoom: (state, { payload }: { payload: number }) => {
      state.roomNo = payload
    },
    setQueueTicket: (state, { payload }: { payload: string }) => {
      state.ticketId = payload
    },
  },
})

export const { setQueueRoom, setQueueTicket } = store.actions

export default store.reducer
